<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <b-tabs pills>
                            <b-tab v-if="hasPermission('SETTINGS_TAXES')" :title="$t('auto.taxes')" active>
                                <Taxes/>
                            </b-tab>
                            <b-tab v-if="hasPermission('SETTINGS_DISCOUNT_LIMIT')" :title="$t('auto.discountLimit')">
                                <DiscountLimit/>
                            </b-tab>
                            <b-tab v-if="hasPermission('SETTINGS_EXCISE_TAX_FOR_COUNTRY')" :title="$t('auto.exciseTaxForCountry')">
                                <ExciseTaxForCountry/>
                            </b-tab>
                            <b-tab v-if="hasPermission('SETTINGS_COEFFICIENT_FOR_DILAPIDATION')" :title="$t('auto.coefficientForDilapidation')">
                                <CoefficientForDilapidation/>
                            </b-tab>
                            <b-tab v-if="hasPermission('SETTINGS_OTHER_CONFIG')" :title="$t('settings.otherConfig')">
                                <other-config></other-config>
                            </b-tab>
                            <b-tab v-if="hasPermission('SETTINGS_GAS_DEVICE_PRICE')" :title="$t('config.gasDevicePrice.titleList')">
                                <gas-device-price></gas-device-price>
                            </b-tab>
                            <b-tab v-if="hasPermission('SETTINGS_YEAR_INDEX')" :title="$t('config.yearIndex.titleList')">
                                <year-index></year-index>
                            </b-tab>
                            <b-tab v-if="hasPermission('SETTINGS_MONTH_INDEX')" :title="$t('config.monthIndex.titleList')">
                                <month-index></month-index>
                            </b-tab>
                            <!--<b-tab title="Файлларни клонлаш">-->
                            <!--<clone-files></clone-files>-->
                            <!--</b-tab>-->
                            <b-tab v-if="hasPermission('SETTINGS_CAR_CATEGORY')" :title="$t('auto.autoManufacture.label')">
                                <auto-manufacture></auto-manufacture>
                            </b-tab>
                            <b-tab v-if="hasPermission('SETTINGS_AUTO_MANUFACTURE')" :title="$t('auto.carCategory.label')">
                                <car-category></car-category>
                            </b-tab>
                            <b-tab v-if="hasPermission('SETTINGS_AUTO_TYPE')" :title="$t('auto.autoType.label')">
                                <auto-type></auto-type>
                            </b-tab>
                            <b-tab v-if="hasPermission('SETTINGS_CAR_COINCIDENTAL')" :title="$t('auto.carCoincidental.label')">
                                <car-coincidental></car-coincidental>
                            </b-tab>
                            <b-tab v-if="hasPermission('SETTINGS_NEW_AUTO_PRICE_LIST')" :title="$t('auto.newAutoPriceList.label')">
                                <auto-price-list></auto-price-list>
                            </b-tab>
                            <b-tab v-if="hasPermission('SETTINGS_AUTO_TEX_PASSPORT_LIST')" :title="$t('auto.autoTexPassport.label')">
                                <tex-passport-list></tex-passport-list>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import bTabs from 'bootstrap-vue/es/components/tabs/tabs';
    import bTab from 'bootstrap-vue/es/components/tabs/tab';
    import Taxes from '@/views/config/auto/Taxes';
    import DiscountLimit from '@/views/config/auto/DiscountLimit';
    import ExciseTaxForCountry from '@/views/config/auto/ExciseTaxForCountry';
    import CoefficientForDilapidation from '@/views/config/auto/CoefficientForDilapidation';
    import OtherConfig from '@/views/config/auto/OtherConfig';
    import GasDevicePrice from "@/views/config/auto/GasDevicePrice";
    import YearIndex from "@/views/config/auto/YearIndex";
    import MonthIndex from "@/views/config/auto/MonthIndex";
    // import CloneFiles from "@/views/config/auto/CloneFiles";
    import AutoManufacture from "@/views/config/auto/auto-manufacture/AutoManufacture";
    import CarCategory from "@/views/config/auto/car-category/CarCategory";
    import AutoType from "@/views/config/auto/auto-type/AutoType";
    import CarCoincidental from "@/views/config/auto/car-coincidental/CarCoincidental";
    import AutoPriceList from "@/views/config/auto/auto-price-list/AutoPriceList";
    import TexPassportList from "@/views/config/auto/tex-passport/TexPassportList";
    // import EvaluationPrices from '@/views/config/evaluation-prices/EvaluationPrices';

    export default {
        name: "AutoConfig",
        components: {
            'b-tabs': bTabs,
            'b-tab': bTab,
            Taxes,
            DiscountLimit,
            ExciseTaxForCountry,
            CoefficientForDilapidation,
            OtherConfig,
            GasDevicePrice,
            YearIndex,
            MonthIndex,
            // CloneFiles,
            AutoManufacture,
            CarCategory,
            AutoType,
            CarCoincidental,
            AutoPriceList,
            TexPassportList
            // EvaluationPrices
        }
    }
</script>

<style scoped>

</style>